import { FC } from 'react';

import { DataTable } from 'components';
import { TruckingCompany } from 'types';

const BookingTruckingCompanies: FC<{ truckingCompanies?: TruckingCompany[] | null }> = ({ truckingCompanies }) => {
  return (
    <div id="booking-trucking-companies" className="card-primary">
      <div className="card-header px-3">
        <h4>TRUCKING COMPANIES</h4>
      </div>
      <div className="card-body offset">
        <DataTable
          clientSidePagination
          columns={[
            { field: 'scacCode', label: 'SCAC CODE', width: 80 },
            { field: 'name', label: 'NAME', width: 80 }
          ]}
          fetchData={async () => truckingCompanies ?? []}
          hideTableControls
          initialColumns={['scacCode', 'name'].map(c => {
            return { field: c, width: 80 };
          })}
          initialPage={{ pageNum: 0, pageSize: 5 }}
          noRowsMessage={<i>Any Trucking Company</i>}
          pageSizeOptions={[5, 25, 50]}
        />
      </div>
    </div>
  );
};

export default BookingTruckingCompanies;
